module.exports = __webpack_public_path__ + "static/media/acadCalendar.6d165aca.svg";